import PromoDelete from './PromoDelete'
export {PromoDelete}
export default PromoDelete
